var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapperFonts"},_vm._l((_vm.fonts),function(font){return _c('div',{staticClass:"fontComponent cmpt"},[_c('label',{staticClass:"labl"},[_c('input',{attrs:{"name":"font","type":"radio"},domProps:{"checked":_vm.currentFont==font,"value":font},on:{"change":function($event){_vm.changeFont(font,$event)}}}),_vm._v(" "),_c('div',{style:({'font-family':font})},[_vm._v(_vm._s(_vm.label.translate_fonts[font]))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f03a1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fonts/Font.vue
// module id = 109
// module chunks = 0